import { normalizePreserveCase } from 'components/Dashboard/utilities/normalizeString';

export default function dynamicTextImage(text) {
  return `<span contenteditable="false" class="crm-mail-merge-substitution" data-crm-mail-merge-substitution-id="${normalizePreserveCase(
    text
  )}" style="background-color: rgb(0, 148, 204, 0.08);
    padding: 0 1px;
    display: inline-block;
    border-radius: 4px;
    color: #0094cc;
    font-family: Arial, Helvetica, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
    font-size: 15px;
    font-weight: 400;
    text-decoration: none;
    font-style: normal;
    ">@${text}</span>`;
}
